import { useEffect } from 'react';
import Router from '../shared/routes';
import ThemeProvider from '../theme';
import ThemeSettings from '../shared/components/settings';
import { ChartStyle } from '../shared/components/chart';
import { ScrollToTop, NotistackProvider, ProgressBarStyle, Toast } from '../shared/components/base';
import MotionLazyContainer from '../shared/components/animate/MotionLazyContainer';
import { useMessagingService } from '../shared/hooks';

export default function App() {
  const { getMessageNotifications } = useMessagingService();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration);
        })
        .catch((err) => {
          console.log('Service Worker registration failed:', err);
        });
    }
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    }
    getMessageNotifications();
  }, []);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            <Router />
            <Toast />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
